import {
  getHomeRoute
} from '@/libs/util'
import routes from '@/router/routes'
import config from '@/config'
// import { Message } from 'ant-design-vue'
const { homeName } = config

export default {
  state: {
    lang: 'en',
    imie: 123456789,
    firstTimeGetIntoDeviceListPage: false, // 第一次进入设备列表页
    dataOfDeviceListPage: [], // 设备列表页的数据
    idOfConnectedDevice: -1, // 当前连接着的设备ID
    theLatestBattery: -1, // 当前连接着的设备的最新电量(-1代表未知;0低电;1一半;满电;)
    theLatesEJuiceId: '0', // 当前连接着的设备的烟弹标识(使用[字符串: "-1"]表示: 没装烟弹)
    theCusumInhalationTime: 0, // 当前连接着的设备的 烟弹累计吸入时长
  },
  mutations: {
    setLang(state, val) {
      state.lang = val
    },
    setImie(state, val) {
      state.imie = val
    },
    setFirstTimeGetIntoDeviceListPage(state, val) {
      state.firstTimeGetIntoDeviceListPage = val;
    },
    setDataOfDeviceListPage(state, val) {
      state.dataOfDeviceListPage = val;
    },
    setIdOfConnectedDevice(state, val) {
      console.info(`更新设备${val}`);
      state.idOfConnectedDevice = val
    },
    setTheLatestBattery(state, val) {
      console.info(`更新电量${val}`);
      state.theLatestBattery = val && !isNaN(parseInt(val)) ? parseInt(val) : -1;
    },
    setTheLatesEJuiceId(state, val) {
      console.info(`更新烟弹${val}`);
      state.theLatesEJuiceId = val
    },
    setTheCusumInhalationTime(state, val) {
      state.theCusumInhalationTime = val && !isNaN(parseInt(val)) ? parseInt(val) : 0;
    },
  },
  actions: {
  }
}
